import { render, staticRenderFns } from "./EditProfilePro.vue?vue&type=template&id=0379d844"
import script from "./EditProfilePro.vue?vue&type=script&lang=js"
export * from "./EditProfilePro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports